import { render, staticRenderFns } from "./AddToMessageGroupOverlay.vue?vue&type=template&id=a04d6852&scoped=true&"
import script from "./AddToMessageGroupOverlay.vue?vue&type=script&lang=js&"
export * from "./AddToMessageGroupOverlay.vue?vue&type=script&lang=js&"
import style0 from "./AddToMessageGroupOverlay.vue?vue&type=style&index=0&id=a04d6852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04d6852",
  null
  
)

export default component.exports